import { MdOutlinePhotoLibrary } from 'react-icons/md';
import * as s from './style';
import IconType from './type';

export const IconJSX = ({
  title,
  color,
  onClick,
  style,
  className,
  size,
  disabled = false,
}: IconType): JSX.Element => (
  <s.IconContainer
    style={style}
    onClick={disabled ? () => null : onClick}
    title={title}
    className={`icon ${className}`}
    disabled={disabled}
    size={size}
  >
    <MdOutlinePhotoLibrary fill={color} />
  </s.IconContainer>
);

export default IconJSX;
